import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Tabs from '@cloudscape-design/components/tabs';
import { useSearchParams } from 'react-router-dom';
import { WeeklyStatusReport } from '../components/reports/WeeklyStatusReport';
import { MyTicketsReport } from '../components/reports/MyTicketsReport';
import { SLAComplianceReport } from '../components/reports/SLAComplianceReport';
import { RecurringIssuesReport } from '../components/reports/RecurringIssuesReport';
import { RootCauseThemesReport } from '../components/reports/RootCauseThemesReport';
import { recordEvent } from '../rum';

const DEFAULT_TAB = 'weekly-status';

export function ReportsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || DEFAULT_TAB;

  const handleTabChange = (tabId: string) => {
    recordEvent('report_view', { report: tabId });
    setSearchParams({ tab: tabId }, { replace: true });
  };

  return (
    <SpaceBetween size="m">
      <Header
        variant="h1"
        description="Operational reports generated from ticket data. Each report can be downloaded as CSV."
      >
        Reports
      </Header>

      <Tabs
        activeTabId={activeTab}
        onChange={({ detail }) => handleTabChange(detail.activeTabId)}
        tabs={[
          {
            id: 'weekly-status',
            label: 'Weekly Status',
            content: <WeeklyStatusReport />,
          },
          {
            id: 'my-tickets',
            label: 'My Tickets',
            content: <MyTicketsReport />,
          },
          {
            id: 'sla-compliance',
            label: 'SLA Compliance',
            content: <SLAComplianceReport />,
          },
          {
            id: 'recurring-issues',
            label: 'Recurring Issues',
            content: <RecurringIssuesReport />,
          },
          {
            id: 'root-cause-themes',
            label: 'Root Cause Themes',
            content: <RootCauseThemesReport />,
          },
        ]}
      />
    </SpaceBetween>
  );
}
